import React, { useContext, useState } from 'react';
import { AdminContext } from '../../contexts/admin.context';
import { XIcon } from '../icons';
import Button from './Button';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

export default function ConfirmationPopup({
  useLeftArrow = false,
  heading,
  description,
  icon = null,
  iconBg = null,
  action = {
    head: '',
    text: '',
    type: 'danger',
    onClick: null,
    icon: null
  },
  cancelButton = {
    text: '',
    onClick: null
  },
  textBox = {
    show: false,
    text: ''
  },
  actionList = null,
  actionListClick = null,
  footerNotes,
  onHide,
  zIndex = 50
}) {
  const { themeConfig: { primary, secondary } = {} } = useContext(AdminContext);
  const [textareaContent, setTextareaContent] = useState('');

  // Update the textarea onChange handler to set the content state
  const handleTextareaChange = (e) => {
    setTextareaContent(e.target.value);
  };

  const Icon = icon;

  return (
    <div
      className="z-50 backdrop-blur-sm fixed top-0 left-0 w-full h-screen flex items-center justify-center"
      style={{
        zIndex: zIndex
      }}>
      <div className="p-4 bg-white w-full h-auto lg:w-10k flex flex-col items-center rounded-xl shadow-lg pb-8">
        <button
          className="p-4 rounded-full text-white self-start shadow-lg"
          style={{ backgroundColor: primary }}
          onClick={onHide}>
          {useLeftArrow ? (
            <ArrowLeftIcon strokeWidth={'4px'} className="w-3 h-3" color="white" />
          ) : (
            <XIcon className="w-3 h-3" color="white" />
          )}
        </button>
        {icon && (
          <div className="self-center mb-6 w-40 h-40">
            <Icon className="w-full h-full" bg={iconBg || secondary} />
          </div>
        )}
        <div className="px-8 text-center">
          {action.head && <h4 className="font-bold">{action.head}</h4>}
          <h2 className="text-3xl font-bold">{heading}</h2>
          <p className="description text-lg mt-2">{description}</p>
        </div>
        {textBox.show && (
          <div className="mt-8 flex flex-col">
            <h4 className="font-semibold">{textBox.text}</h4>
            <textarea
              value={textareaContent}
              onChange={handleTextareaChange}
              rows="4"
              className="block p-2.5 w-full max-w-md text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"></textarea>
          </div>
        )}
        {actionList && (
          <div className="mt-8 gap-4 flex flex-row flex-wrap items-center justify-center">
            {actionList.map((actionItem) => (
              <Button
                key={actionItem._id}
                // type="button"
                buttonType={actionItem.type || 'primary'}
                onClick={() =>
                  actionItem.onClick ? actionItem.onClick() : actionListClick(actionItem._id)
                }>
                {actionItem.name}
              </Button>
            ))}
          </div>
        )}
        <div className="mt-8 flex gap-4">
          {cancelButton?.text && (
            <Button buttonType="outline" onClick={() => cancelButton.onClick(textareaContent)}>
              {cancelButton.text}
            </Button>
          )}
          {action.text && (
            <Button
              buttonType="primary"
              onClick={() => (textBox.show ? action.onClick(textareaContent) : action.onClick())}>
              {action.text}
            </Button>
          )}
        </div>
        {footerNotes && <p className="text-sm mt-4 text-gray-400 max-w-md">{footerNotes}</p>}
      </div>
    </div>
  );
}
